import { reactive, computed } from 'vue';

export default defineNuxtPlugin(() => {
    const state = reactive({});

    const $wait = {
        start(key) {
            state[key] = true;
        },

        end(key) {
            state[key] = false;
        },

        // IMPORTANT: Return a computed getter that tracks state[key]
        waiting(key) {
            return computed(() => state[key] === true).value;
        },

        // debug
        state
    };

    return {
        provide: {
            wait: $wait
        }
    };
});
